import React, { useState } from "react";
import serv from "../../img/serv.jpg";
const services = [
  {
    name: "خبرة طويلة وموثوقية عالية",
    details:
      "نمتلك سنوات طويلة من الخبرة في مجال الشحن والخدمات اللوجستية، ولدينا سجل حافل بالإنجازات والنجاحات التي تدل على موثوقيتنا والتزامنا بتقديم أفضل خدمة لعملائنا.",
  },
  {
    name: "شبكة عالمية واسعة",
    details:
      "نمتلك شبكة عالمية واسعة من الشركاء والوكلاء في مختلف أنحاء العالم، مما يمكننا من تقديم خدمات شحن دولية شاملة وسريعة إلى أي وجهة في العالم.",
  },
  {
    name: "حلول مبتكرة وتقنيات متطورة",
    details:
      "نستخدم أحدث التقنيات والحلول المبتكرة في مجال الشحن والخدمات اللوجستية، مما يضمن كفاءة عملياتنا وسرعة توصيل شحناتك.",
  },
  {
    name: "فريق محترف ومتخصص",
    details:
      "يضم فريق عملنا خبراء ومتخصصين في مجال الشحن والخدمات اللوجستية، وهم على استعداد دائم لتقديم الدعم والمشورة وتلبية احتياجاتك بأعلى مستوى من الاحترافية.",
  },
  {
    name: "أسعار تنافسية وعروض خاصة",
    details:
      "نقدم أسعارًا تنافسية وعروضًا خاصة لعملائنا، ونحرص دائمًا على تقديم أفضل قيمة مقابل المال.",
  },
  {
    name: "مرونة وتلبية الاحتياجات الخاصة",
    details:
      "نتميز بالمرونة في التعامل مع احتياجات عملائنا الخاصة، ونقدم حلولًا مخصصة لتلبية متطلباتهم الفريدة.",
  },
  {
    name: "التزام بالجودة والسلامة",
    details:
      "نلتزم بأعلى معايير الجودة والسلامة في جميع عملياتنا، ونحرص على سلامة بضائعك وتوصيلها في أفضل حالة.",
  },
  {
    name: "خدمة عملاء استثنائية",
    details:
      "نضع رضا عملائنا في مقدمة أولوياتنا، ونقدم خدمة عملاء استثنائية تتميز بالسرعة والفعالية والاحترافية.",
  },
];
const WhyUs = () => {
  const [activeService, setActiveService] = useState(null);

  return (
    <div className="container WhyUs">
      <h1 className="my-5 fw-bold">
        لماذا نحن خيارك الأفضل في عالم الشحن والخدمات اللوجستية؟
      </h1>
      <div className="row align-items-center">
        <div className="col-md-6">
          <ul className="services-list">
            {services.map((service, index) => (
              <li key={index} onClick={() => setActiveService(index)}>
                <h6 className="fw-bold">{service.name}</h6>
                {activeService === index && <p>{service.details}</p>}
              </li>
            ))}
          </ul>
        </div>

        <div className="col-md-6">
          <div className="img">
          <img src={serv} alt="" />

          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyUs;
